import { useState } from 'react';
import { faqList } from '@/mocks/manga';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于韩漫屋，你想知道的都在这里</p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqList.map((faq, index) => (
            <div key={index} className="bg-background-50 rounded-xl overflow-hidden">
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.question}</span>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-500 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}